import { envConfig } from '@root/env';
import { Post } from '@/service/request/server';
import { getProjectNameHeader } from '@/utils/imUtils';

const baseUrl = envConfig.formalServer + '/plat/admin/im/message/';

function baseApi() {

    function deleteData(data, projectName) {
        return Post(baseUrl + 'deleteImMessage', data, getProjectNameHeader(projectName));
    }

    function update(data, projectName) {
        return Post(baseUrl + 'updateImMessage', data, getProjectNameHeader(projectName));
    }

    function query(data, projectName) {
        return Post(baseUrl + 'queryImMessage', data, getProjectNameHeader(projectName));
    }

    function sendMsg(data, projectName) {
        return Post(envConfig.formalServer + '/plat/im/message/send', data, getProjectNameHeader(projectName));
    }

    return {
        deleteData, update, query, sendMsg
    };
}

export const imMessageApi = baseApi();
